<template>
  <div id="app" :class="isPc ? 'pc' : 'phone'">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isPc: true,
      phoneHieght: ''
    }
  },
  created() {
    this.getDeviceModel();
  },
  methods: {
    getDeviceModel() {
      var os = function () {
        var ua = navigator.userAgent,
          isWindowsPhone = /(?:Windows Phone)/.test(ua),
          isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
          isAndroid = /(?:Android)/.test(ua),
          isFireFox = /(?:Firefox)/.test(ua),
          isChrome = /(?:Chrome|CriOS)/.test(ua),
          isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
          isPhone = /(?:iPhone)/.test(ua) && !isTablet,
          isPc = !isPhone && !isAndroid && !isSymbian;
        return {
          isTablet: isTablet,
          isPhone: isPhone,
          isAndroid: isAndroid,
          isPc: isPc
        };
      }();
      // 安卓，苹果，平板
      let isPc = true;
      if (os.isAndroid || os.isPhone || os.isTablet) {
        console.log("手机")
        isPc = false;
      } else if (os.isPc) {
        console.log("电脑")
        isPc = true;
      }

      this.isPc = isPc;
      sessionStorage.setItem('isPc', isPc)
    },
  }
};
</script>

<style>
.pc {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  min-width: 1200px;
}

.phone {
  position: absolute;
  width: 100%;
  height: 100%;
  /* box-sizing: border-box; */
  border: 1px solid black;
  font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue